import { ApolloClient, ApolloQueryResult } from '@apollo/client';
import { GetAllCountriesDocument, GetAllCountriesQuery, LocaleDocument, LocaleQuery, LocaleQueryVariables } from '../codegen/gateway/graphql';
import { GraphServer } from '../constants';
import { executeQueryIgnoreError } from '../utils';

export * from '../codegen/gateway';
export * from '../codegen/gateway/graphql';

export const getLocale = async <TCacheShape>(
	apolloClient: ApolloClient<TCacheShape>,
	variables: LocaleQueryVariables,
): Promise<ApolloQueryResult<LocaleQuery>> => {
	return executeQueryIgnoreError(apolloClient, GraphServer.GLOBALIZATION, LocaleDocument, variables);
};

export const getAllCountries = async <TCacheShape>(apolloClient: ApolloClient<TCacheShape>): Promise<ApolloQueryResult<GetAllCountriesQuery>> => {
	return executeQueryIgnoreError(apolloClient, GraphServer.GLOBALIZATION, GetAllCountriesDocument);
};
